<template>
  <v-navigation-drawer
    v-model="drawer"
    color="rgba(66, 182, 245, 0.75)"
    expand-on-hover
    mini-variant
    permanent
    width="270"
    mini-variant-width="40"
    absolute
    hide-overlay
    style="z-index: 2;"
  >
    <v-list-item class="px-2">
      <v-img :src="require(`@/assets/logo.png`)"></v-img>
      <v-list-item-title>COVID-19 Strategy</v-list-item-title>
    </v-list-item>

    <v-list dense nav class="pt-8">
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-information-outline</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-content>
            Explore water depth and extent from flood modelling
          </v-list-item-content>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-wave</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Flood Simulations</v-list-item-title>
          <v-radio-group v-model="year" class="d-flex pl-2"
            @change="$store.commit('data/changeYear', year)">
            <v-radio label="2015" value="2015"></v-radio>
            <v-radio label="2013" value="2013"></v-radio>
            <v-radio label="1995" value="1995"></v-radio>
          </v-radio-group>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-layers-outline</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Map Layers</v-list-item-title>
          <v-radio-group
            v-model="mapLayer"
            @change="$store.commit('data/changeMapLayer', mapLayer)"
          >
            <v-radio
              v-for="(layer, i) in mapLayers"
              :key="i"
              :label="layer"
              :value="layer"
            ></v-radio>
          </v-radio-group>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "NavDrawer",

  data() {
    return {
      drawer: true,
      year: "2015",
      mapLayer: "Outdoors",
      mapLayers: [
        "Satellite",
        "Streets",
        "Satellite with Streets",
        "Outdoors",
        "Light",
        "Dark"
      ]
    };
  }
};
</script>

<style scoped></style>
